import axios from "axios";

function userLogin(objLogin) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3015"
			axios.post(process.env.ROOT_API + "/users/login",
				{
					user: objLogin.user,
					passwd: objLogin.passwd
				}).then(result => {
					resolve(result.data.documents)
				}).catch(error => {
					reject(error.response)
				})
		} catch (error) {
			console.log('error in userLogin: ', error)
		}
	})
}

function userSearch(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3016"
			axios.get(process.env.ROOT_API + "/users/search/" + objAux.user, {
				headers: {
					'Authorization': objAux.token
				}
			}).then(result => {
				resolve(result.data.documents[0])
			}).catch(error => {
				reject(error.response)
			})
		} catch (error) {
			console.log('error in userSearch: ', error)
		}
	})
}

function institutionSearch(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3010"
			axios.get(process.env.ROOT_API + "/institutions/search/" + objAux.id, {
				headers: {
					'Authorization': objAux.token
				}
			}).then(result => {
				resolve(result.data.documents[0])
			}).catch((error) => {
				reject(error.response)
			})
		} catch (error) {
			console.log('institutionSearch: ', error)
		}
	})
}

function searchPersons(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3034"
			axios
				.put(process.env.ROOT_API + "/persons/query", {
					email: objAux.user
				}, {
					headers: {
						'Authorization': objAux.token
					}
				})
				.then(result => {
					resolve(result.data.documents[0]);
				})
				.catch(error => {
					reject(error.response);
				});
		} catch (err) {
			console.log("err in searchPersons: ", err);
		}
	});
}

function searchPersonsIdUser(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3034"
			axios
				.put(process.env.ROOT_API + "/persons/query", {
					user: objAux.user
				}, {
					headers: {
						'Authorization': objAux.token
					}
				})
				.then(result => {
					resolve(result.data.documents[0]);
				})
				.catch(error => {
					reject(error.response);
				});
		} catch (err) {
			console.log("err in searchPersons: ", err);
		}
	});
}

function searchPersonsIdUser(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3034"
			axios
				.put(process.env.ROOT_API  + "/persons/query", {
					user: objAux.user
				}, {
						headers: {
							'Authorization': objAux.token
						}
					})
				.then(result => {
					resolve(result.data.documents[0]);
				})
				.catch(error => {
					reject(error.response);
				});
		} catch (err) {
			console.log("err in searchPersons: ", err);
		}
	});
}

function recover_passwd(objData) {
	return new Promise((resolve, reject) => {
		let port = ""

		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3044"
		axios.post(process.env.ROOT_API + "/recover_passwd", {
			email: objData.email
		}).then(result => {
			resolve(result.data.documents)
		}).catch(error => {
			reject(error)
		})
	})
}

export {
	userLogin,
	userSearch,
	searchPersons,
	institutionSearch,
	recover_passwd,
	searchPersonsIdUser
}



// WEBPACK FOOTER //
// ./src/components/login/loginSer.js